import React from "react"
import '../../css/style.css'

import Header from "../components/header"
import Footer from "../components/footer"

export default function Policy() {
  return (
    <div id="page">
      <Footer />
      <Header />

      <div id="page-wrapper">
        <div className="container">
            <div className = "col-md-12">
                <div className="policy-content">
                    <h1>Policy & Warranty</h1>
                    <h2>Policy</h2>
                    <p>1. When customer requests for a refund, $30 will be deducted from the refund, for labour fee.</p>
                    <p>2. We do not offer any refunds of parts after 30 days of purchase.</p>
                    <p>3. When a refund is requested , the part used for the repair must be returned as its original state (No cracks or any form of damage).</p>
                    <p>4. These terms only apply to the repaired parts.</p>
                    <p>5. When we are unable to repair the phone due to technical reasons, customers do not need to pay.</p>
                    <p>6. We use Generic Parts for repair.</p>

                    <h2>Warranty</h2>
                    <p>1. Our Warranty period is 3 months.</p>
                    <p>2. We cannot offer any form of warranty on devices for the situation below.</p>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;2-1. Accidental / International (any form of) damage after Repair. (droping etc) </p>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;2-2. If the phone has been repaired by other shops after a repair from us.</p>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;2-3. If the phone has damaged from water.</p>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;2-4. If the phone has Touch IC issue (Freezing etc.)</p>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;2-5. If the phone has Motherboard issue</p>
                </div>
            </div>
        </div>
      </div>
    </div>
  ) 
}